// extracted by mini-css-extract-plugin
export default {"accountContainer":"logout-form_accountContainer__rxgVM","logButtonContainer":"logout-form_logButtonContainer__B20JX"};